import { useMemo } from 'react';

import { createLogger } from '@cko/dashboard-shared';

import { getFallbackLogger } from './fallbackLogger';

export const useMfeLogger = (mfe?: string, module?: string, team?: string) => {
  const mfeLogger = useMemo(() => {
    if (!mfe || !module || !team) {
      return getFallbackLogger();
    }

    return createLogger({
      context: {
        mfe,
        module,
        team,
      },
    });
  }, [mfe, module, team]);

  return mfeLogger;
};
